export const CONTRACT_ADDRESS = '0xD6D6dFC821c9249718D06971592801C90Cc0b6F5';
export const CHAINID = '0x1';
export const OPENSEA_URL = 'https://opensea.io/collection/artifacts-gg';
export const OPENSEA_ASSET_URL = `https://opensea.io/assets/${CONTRACT_ADDRESS}/`;
export const FALLBACK_RPC_URL = 'https://rpc.flashbots.net';
